import React from "react";
import { Tag } from "antd";
export default function LockoutTag() {
    return React.createElement(Tag, { color: "gray" }, "Lockout");
}
